import * as React from "react";
const SvgNextPage = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={7}
    height={12}
    fill="none"
    {...props}
  >
    <path
      stroke="#414141"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m1 11 5-5-5-5"
    />
  </svg>
);
export default SvgNextPage;
